<div *ngIf="isShown" class="loader-wrapper">
  <div class="loading-animation">
    <div *ngFor="let item of loadingSpinner"></div>
  </div>
</div>
